const HALF_DAY_MS = 12 * 60 * 60 * 1000

/**
 * The day a person was born, as 'YYYY-MM-DD', in every time zone. Sign-up
 * used to send the birth date as the midnight of the person's own clock, so
 * east of Greenwich the server holds the evening before (22:00 or 23:00 UTC).
 * Such a value is never more than 12 hours away from the midnight of the day
 * the person typed: adding 12 hours and keeping the UTC date gives that day
 * back, and changes nothing for a date already at midnight.
 */
export const birthDayOf = (value?: string | null): string => {
  if (!value) return ''
  const time = new Date(value).getTime()
  if (Number.isNaN(time) || !/^\d{4}-\d{2}-\d{2}/.test(value)) return value
  return new Date(time + HALF_DAY_MS).toISOString().slice(0, 10)
}
